import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../../commonUtils";
import Header from "../../Header/header";
import { Modal } from 'react-responsive-modal';
import TransactionServices from "../TransactionServices";
import ViewUploadFileLogBox from "./ViewUploadFileLog";

export default function GooglePlay(subEntity: any) {

    const [showtab, setShowTab] = useState(1);
    const [loop, setloop] = useState(1);
    let [activeMenu, setActiveMenu] = useState("GooglePlay");

    const [searchFor, setSearchFor] = useState("");
    var dataLink = "pageSize=10&pageNumber=1";
    const [currentList, initCurrentList] = useState<any[]>([]);
    const [totalRows, setTotalRows] = useState(1);


    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }

    const [displaytabs, setDisplayTabs] = useState(1);
    /* const currentPage = (e: React.SetStateAction<number>) => {
        setDisplayTabs(e);
        return 1;
    } */

    const tabs = [
        {
            id: 1, keys: "Manual", title: "Manual"
        },
        {
            id: 2, keys: "Auto", title: "Auto"
        },
    ]

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        totalRows: 0
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        currentPage(showtab)
    }

    const currentPage = (e: number) => {
        setShowTab(e);

        if (searchFor.length > 0) {
            dataLink = dataLink + "&searchFor=" + searchFor
        }
        if (e === 1) {
            TransactionServices.googlePlayManual(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 2) {
            TransactionServices.googlePlayAuto(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
    }

    let [checkReportData, setCheckReportData] = useState(false);
    let [checkReportNoDate, setCheckReportNoDate] = useState(false);
    let [getReportSuccess, setGetReportSuccess] = useState(false);
    let [checkNoDate, setCheckNoDate] = useState(false);



    let [fileUploadHistoryStatus, setFileUploadHistoryStatus] = useState(false);
    const viewUploadHistory = () => {
        setFileUploadHistoryStatus(true)
    }

    const ViewUploadFileLogClose = () => {
        fileUploadHistoryStatus = false
        setFileUploadHistoryStatus(false)
    }
    let [collapsedUploadFile, setcollapsedUploadFile] = useState(false);
    let [collapsedGetReport, setcollapsedGetReport] = useState(false);



    return (

        <div className="ws-12 pm">

            <div className="ws-12 mbs">
                <ul className="nav nav-tabs nav-justified">
                    <li data-ng-className="{active: isActiveTab('manual')}" data-ng-click="openTab('manual')" className="hide">
                        <a className=" ">Manual</a>
                    </li>
                    <li data-ng-className="{active: isActiveTab('auto')}" data-ng-click="openTab('auto')" className="hide" >
                        <a>Auto</a>
                    </li>
                    <a id="1" className={showtab === 1 ? "btn-success active" : "btn-success"} onClick={() => currentPage(1)}>Manual</a>
                    <a id="2" className={showtab === 2 ? "btn-success active" : "btn-success"} onClick={() => currentPage(2)}>Auto</a>
                </ul>
            </div>

            {showtab === 1 && <div className="slide" data-ng-show="isActiveTab('manual')">

                <div className="box">
                    <div className="box-header well">
                        <h2>
                            <i className="icon-upload"></i> Upload File
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedUploadFile(!collapsedUploadFile)}>
                                <i className={collapsedUploadFile ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                            {collapsedUploadFile && <>
                                <button title="File Upload History" className="btn-info btn-xxs pull-right ng-hide" onClick={() => viewUploadHistory()}><i className="icon-history"></i> </button>
                            </>}
                        </h2>
                    </div>

                    {collapsedUploadFile && <>
                        <div className="box-content" >
                            <div className="ws-12">
                                <div className="ws-3">
                                    <div className="form-format">
                                        <label className="control-label">Date</label>
                                        <div className="label-entries">
                                            <input type="text" placeholder="Select month and year" readOnly id="manualDate" name="manualDate" />

                                        </div>
                                    </div>
                                </div>
                                <div className="ws-3 mtl">
                                    <label className="control-label ">  Upload File</label>
                                    <div className="label-entries">
                                        <label className="btn icon-btn edit btn-file btn-sm">
                                            <i className="icon-upload"></i>
                                            <input type="file" className="hide" />
                                        </label>
                                    </div>
                                </div>
                                <div className="ws-6">
                                    <div className="form-format ptl">
                                        <div className="progress">
                                            <div className="progress-bar ">
                                                %
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                checkNoDate && <div className="alert alert-info">Please select a month</div>
                            }
                        </div>
                    </>}
                </div>

            </div>}

            {showtab === 2 && <div className="slide" data-ng-show="isActiveTab('auto')">

                <div className="box">
                    <div className="box-header">
                        <h2 className="ws-12">
                            <i className="icon-upload"></i> Get File
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedGetReport(!collapsedGetReport)}>
                                <i className={collapsedGetReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                            <button title="File Upload History" className="btn-info btn-xxs-pull-right ng-hide" onClick={() => viewUploadHistory()}><i className="icon-history"></i> </button>
                        </h2>
                    </div>
                    <div className="box-content ng-hide" >
                        <div className="ws-12">
                            <h2>Work in Progress</h2>
                        </div>
                    </div>
                </div>

            </div>}


            <div className="box mts">
                <div className="box-header well">
                    <h2>
                        <i className="icon-upload"></i> Get Report
                        <button className="icon-btn info pull-right m2" onClick={() => setcollapsedGetReport(!collapsedGetReport)}>
                            <i className={collapsedGetReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                        </button>
                    </h2>
                </div>
                {collapsedGetReport && <>
                    <div className="box-content ng-hide" data-ng-hide="collapsedGetReport">
                        <div className="row-fluid form-horizontal form-condensed m0 ml">
                            <div className="ws-3">
                                <div className="form-format">
                                    <label className="control-label">Date</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Select month and year" data-ng-click="open($event,'getReportDate')" data-ng-model="getReportDate" is-open="datepickers.getReportDate" readOnly id="getReportDate" name="getReportDate" />
                                    </div>
                                </div>
                            </div>
                            <div className="ws-3">
                                <div className="form-format">
                                    <label className="control-label">Report Type</label>
                                    <div className="label-entries">
                                        <select data-ng-model="selectReport"  >
                                            <option value="Transaction" data-ng-selected="true" selected>Transaction</option>
                                            <option value="Locker" >Locker</option>
                                            <option value="Subscription" >Subscription</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="form-format">
                                    <a className="btn icon-btn edit" data-ng-click="getGooglePlayReport(selectReport, getReportDate)">
                                        <span data-ng-hide="googlePlayReportList.length &gt; 0" ><i className="icon-search1"></i> Search</span>
                                        <span data-ng-show="googlePlayReportList.length &gt; 0" className=" ng-hide"><i className="icon-reload"></i> Refresh</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="row-fluid">
                            <div className="table-responsive_big">
                                {
                                    checkReportData && <div className="alert alert-ing">No data found for this month</div>
                                }
                                {
                                    checkReportNoDate && <div className="alert alert-ing">Please select a month</div>
                                }
                                {
                                    getReportSuccess && <div className="alert alert-ing">Generation of Report(s) in
                                        process</div>
                                }
                                <table className="table ng-hide" data-ng-show="googlePlayReportList.length &gt; 0">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Report</th>
                                            <th>Territory</th>
                                            <th>Currency</th>
                                            <th>Quantity</th>
                                            <th>Net Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="box-footer ng-hide" data-ng-hide="collapsedGetReport">
                            <a className="icon-btn warning  ng-hide" data-ng-show="googlePlayReportList.length != 0 &amp;&amp; invRefCheck.length == 1" data-ng-click="openGenerateInvoice(selectReport)">
                                <i className="icon-plus1-circle"></i> Generate Invoice
                            </a>
                            <a className="btn icon-btn edit btn-sm ng-hide" data-ng-show="googlePlayReportList.length &gt; 0" data-ng-click="reportExport(selectReport)">
                                <span><i className="icon-download1"></i></span>
                            </a>
                        </div>
                    </div>
                </>}
            </div>

            {
                (() => {
                    if (fileUploadHistoryStatus) {
                        return <ViewUploadFileLogBox param={fileUploadHistoryStatus} ViewUploadFileLogClose={ViewUploadFileLogClose} />
                    }
                })()
            }
        </div>
    );
}
